import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const StyledFlex = styled.div`
  display: ${props => props.display || 'flex'};

  ${({ justifyContent }) =>
    justifyContent && 'justify-content:' + justifyContent + ';'}
  ${({ flexDirection }) =>
    flexDirection && 'flex-direction:' + flexDirection + ';'}
  ${({ flexGrow }) => flexGrow && 'flex-grow:' + flexGrow + ';'}
  ${({ flexBasis }) => flexBasis && 'flex-basis:' + flexBasis + ';'}
  ${({ flexShrink }) => flexShrink && 'flex-shrink:' + flexShrink + ';'}
  ${({ flexWrap }) => flexWrap && 'flex-wrap:' + flexWrap + ';'}
  ${({ flex }) => flex && 'flex:' + flex + ';'}
  ${({ alignItems }) => alignItems && 'align-items:' + alignItems + ';'}
  ${({ gap }) => gap && 'gap:' + gap + ';'}
  ${({ rowGap }) => rowGap && 'row-gap:' + rowGap + ';'}
  ${({ columnGap }) => columnGap && 'column-gap:' + columnGap + ';'}

  ${({ margin }) => margin && 'margin:' + margin + ';'}
  ${({ padding }) => padding && 'padding:' + padding + ';'}
  ${({ width }) => width && 'width:' + width + ';'}
  ${({ height }) => height && 'height:' + height + ';'}
  ${({ maxWidth }) => maxWidth && 'max-width:' + maxWidth + ';'}
  ${({ maxHeight }) => maxHeight && 'max-height:' + maxHeight + ';'}
  ${({ minWidth }) => minWidth && 'min-width:' + minWidth + ';'}
  ${({ minHeight }) => minHeight && 'min-height:' + minHeight + ';'}
`

export const Flex = ({ children, ...props }) => {
  return <StyledFlex {...props}>{children}</StyledFlex>
}

Flex.propTypes = {
  children: PropTypes.node,
  display: PropTypes.oneOf([
    'flex',
    'inline-flex',
    'inline-block',
    'block',
    'none',
    'initial',
    'inherit'
  ]),
  justifyContent: PropTypes.oneOf([
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
    'space-evenly',
    'start',
    'end',
    'left',
    'right',
    'unsafe',
    'safe',
    'unsafe-stretch',
    'safe-stretch'
  ]),
  flexDirection: PropTypes.oneOf([
    'row',
    'row-reverse',
    'column',
    'column-reverse'
  ]),
  flexGrow: PropTypes.number,
  flexBasis: PropTypes.string,
  flexShrink: PropTypes.number,
  flexWrap: PropTypes.oneOf([
    'nowrap',
    'wrap',
    'wrap-reverse',
    'initial',
    'inherit',
    'unset'
  ]),
  flex: PropTypes.string,
  alignItems: PropTypes.oneOf([
    'flex-start',
    'flex-end',
    'center',
    'baseline',
    'stretch',
    'inherit',
    'unset'
  ]),
  gap: PropTypes.string,
  rowGap: PropTypes.string,
  columGap: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  maxWidth: PropTypes.string,
  maxHeight: PropTypes.string,
  minWidth: PropTypes.string,
  minHeight: PropTypes.string
}
